import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { RestrictionCompartments, restrictionStorageKey } from '..';

export class RestrictionsListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.PricebooksSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(restrictionStorageKey)
    private readonly cache: DataCache<RestrictionCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('restrictions');
        } else {
          this.cache.reset('restrictions');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
